import React from "react";
import { SellerTable } from "../../components/datatable/sellerDatatable";

const Sellers = () => {
  return <SellerTable />;
};

export default Sellers;
